import { all } from 'redux-saga/effects';
import userSaga from './sagas/user-saga';
import paymentSaga from './sagas/payment-saga';

export default function* rootSaga() {
  yield all([
    userSaga(),
    paymentSaga(),
  ]);
}
